import { useCallback } from 'react';
import { env } from '@/env';
import { useRegistration } from '@/context/RegistrationContext';

// Branch reads `~feature` as an analytics tag, so installs can be split by entry point.
export const WREG_QR_FEATURE = 'webreg_desktop_qr';

export type WregAppLinkOptions = { feature?: string; includeEmail?: boolean };

// A QR stays on screen and can be scanned or screenshotted, so it carries no email.
export const WREG_QR_LINK: WregAppLinkOptions = { feature: WREG_QR_FEATURE, includeEmail: false };

export const wregAppLink = (
  email: string,
  promoCode?: string | null,
  { feature, includeEmail = true }: WregAppLinkOptions = {},
): string => {
  const code = promoCode?.trim() || env.ACCESS_PILOT_PROMO_CODE;
  const emailParam = email && includeEmail ? `&email=${encodeURIComponent(email)}` : '';
  const featureParam = feature ? `&~feature=${encodeURIComponent(feature)}` : '';
  return `${env.BRANCH_URL}/?promoCode=${encodeURIComponent(code)}${emailParam}${featureParam}`;
};

export const useWregAppLink = (): ((options?: WregAppLinkOptions) => string) => {
  const { registrationData } = useRegistration();
  const email = registrationData.account.email;
  const promoCode = registrationData.promoCodeData?.code;
  return useCallback(
    (options?: WregAppLinkOptions) => wregAppLink(email, promoCode, options),
    [email, promoCode],
  );
};
